import { useState, useEffect, useCallback } from 'react';
import { authedApiFetch } from 'utils/Api';

const useSalesforceReports = () => {
	const [reports, setReports] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

	const fetchReports = useCallback(async () => {
		setLoading(true);
		setError(null);

		try {
			const data = await authedApiFetch({
				endpoint: '/salesforce_reports',
				method: 'GET',
				params: {
					// TODO: optionally pass other sorting options
					sort_by: 'last_viewed_date'
				}
			});

			setReports(data || []);
			setTotalCount(data?.length || 0);
		} catch (err) {
			// 404 means no connection record found
			if (err.message?.includes('404')) {
				setError('not_connected');
			}
			// 403 or 424 means connection exists but is stale/broken
			else if (err.message?.includes('403') || err.message?.includes('424')) {
				setError('reconnect_required');
			} else {
				setError(err.message || 'Failed to fetch Salesforce reports');
			}
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		fetchReports();
	}, [fetchReports]);

	return { reports, loading, error, totalCount, refetch: fetchReports };
};

export default useSalesforceReports;
